import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-3 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-file-list-3-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-foreground-900">Vigorbuy Spread</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Your complete resource for Vigorbuy Spreadsheet — organized product categories, buying guides, and expert shopping strategies.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-4">Quick Links</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Home</Link>
              <Link to="/guide/vigorbuy-spreadsheet-complete-guide" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Complete Guide</Link>
              <a href="#categories" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Categories</a>
              <a href="#faq" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">FAQ</a>
            </div>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-4">Resources</h4>
            <div className="flex flex-col gap-2">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Main Website</a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Vigorbuy Spreadsheet</a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Shop Now</a>
            </div>
          </div>

          {/* Disclaimer */}
          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-4">Disclaimer</h4>
            <p className="text-xs text-foreground-500 leading-relaxed">
              Vigorbuy Spread is an independent informational resource. We are not directly affiliated with any brands mentioned. All product links direct to the official main website. Always verify product details before purchasing.
            </p>
          </div>
        </div>

        <div className="border-t border-background-200 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Vigorbuy Spread. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">Privacy</a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}